<template>
  <div class="page__space">
    <div class="page-separator" :style="style.separator"></div>
    <!-- <div
        style="position: absolute; bottom: 0px"
        :style="{ width: `${config.width}${config.unit}`, height: `${config.height}${config.unit}` }"
      >
        <img
          style="width: 20cm; height: 21cm; position: static; display: block"
          src="https://innova-apps.sfo3.digitaloceanspaces.com/PalmeraCocoTeams.png"
        />
      </div> -->

    <!-- page content -->
    <div class="page" :style="pageStyle">
      <!-- textura fondo -->
      <!-- <div><img src="https://innova-apps.sfo3.digitaloceanspaces.com/TexturaCocoTeams.png"></div> -->
      <div :style="pageInnerStyle">
        <div>
          <!-- page header -->
          <div :style="style.page.header">
            <slot name="header"></slot>
          </div>
          <!-- page body -->
          <div :style="style.page.body">
            <slot></slot>
          </div>
        </div>
        <!-- page footer -->
        <div :style="style.page.footer">
          <slot name="footer"></slot>
        </div>
      </div>
      <!-- Marca de agua -->
      <div
        style="position: absolute"
        :style="{
          width: pageStyle.width,
          height: pageStyle.height,
        }"
      >
        <slot name="watermark">
          <img
            v-if="!!watermarkSrc"
            :style="{
              width: pageStyle.width,
              height: pageStyle.height,
            }"
            :src="watermarkSrc"
          />
        </slot>
      </div>
    </div>

    <div class="page-separator" :style="style.separator"></div>
  </div>
</template>

<script>
export default {
  name: "PreviewPage",

  props: {
    config: {
      type: Object,
      default: () => ({
        unit: "mm",
        margins: [10, 10, 10, 10],
        width: 0,
        height: 0,
      }),
    },
    watermarkSrc: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    style: {
      separator: { height: "10px" },
      page: {
        header: { overflow: "hidden" },
        body: { "flex-grow": 1, overflow: "hidden" },
        footer: { overflow: "hidden" },
      },
    },
  }),

  computed: {
    pageStyle() {
      const { unit, width, height } = this.config;

      return {
        height: `${height}${unit}`,
        width: `${width}${unit}`,
        margin: `0 auto`,
        "background-color": "#fff",
        display: "flex",
        "flex-direction": "column",
      };
    },
    pageInnerStyle() {
      const { unit, height, width, margins } = this.config;
      const padding = margins.reduce(
        (accum, value) => accum + ` ${value}${unit}`,
        ""
      );
      return {
        height: `${height - margins[0] - margins[2]}${unit}`,
        width: `${width - margins[1] - margins[3]}${unit}`,
        padding: `${padding}`,
        display: "flex",
        "flex-direction": "column",
        "justify-content": "space-between",
      };
    },
  },
};
</script>
